export const baseURL = 'https://bettrleads-api.fractolabs.com';
export const basePromoURL = 'https://bettrtrade.fractolabs.com';
export const dashboardName = 'BETTR Leads';
export const supportEmail = 'info@bettrleads.com';
// export const stripePubKey = 'pk_live_51RYXtyGjg1gL1pWuqrlgaqOaJOyVfMB4nQNEDwywT8H6JSElRVFsHHPL0T3pqYSyb2eTNZRgy4whqBlMAOkJzPOQ00pS4XRxAA';
export const stripePubKey = 'pk_live_51SgpINC4nmBEuogTZfNH3SUxZp0ZRk4wYGmrqucfT1ZDqe9mqsAWFuCiBau69YmBcF0njefJRRgwyZ9b0PbZO4n800mRat6oqS';
export const stripePriceIdStart = 'price_1TGRimC4nmBEuogTl5c5Q20v';
export const stripePriceIdPro = 'price_1TGRj1C4nmBEuogTAbQCilc6';
export const stripePriceIdAgency = 'price_1TGRjGC4nmBEuogTfMJASxiB';
